<ng-container 
  *ngIf="{
    searchOptions: searchOptions$ | async,
    transactions: transactions$ | async,
    numberOfTransactions: totalNumberOfTransactions$ | async
  } as data">
  <terra-transactions-list
    [isLp]="false"

    [transactions]="data.transactions"
    [exportTransactionsParameters]="{searchOptions: data.searchOptions, bankAccountId: clientBankAccountId, bankType: 'external'}"
    [pageSize]="data.searchOptions?.pageSize"
    [pageNumber]="data.searchOptions?.pageNumber"
    [totalTransactionsNumber]="data.numberOfTransactions"
    [loading]="isLoading$"
    
    (onFilterChanged)="onFilterChanged($event)"
    (onDirectionChanged)="onDirectionChanged($event)"
    (onDateRangeChanged)="onDateRangeChanged($event)"
    (onPageSizeChanged)="onPageSizeChanged($event)"
    (onPageNumberChanged)="onPageNumberChanged($event)"
    (onExportSelected)="onExportSelected($event)"
  />
</ng-container>
